const props = {
  MuiButtonBase: {
    disableRipple: true,
  },
}

export default props
